// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__l3NZU","col":"styles_col__1zsBZ"};